import React, { PureComponent } from 'react';
import { Transition } from 'react-transition-group';
import { TweenLite, Back } from 'gsap';
import Snackbar from '@material-ui/core/Snackbar';
import axios from 'axios';

import './GameIndex.scss';
import Cookies from 'universal-cookie';
import { CAMS_URL, FETCH_URL } from '../../constants/ServerLinks';

const duration = 300;

const defaultStyle = {
  transition: `opacity ${duration}ms ease-in-out, maxHeight ${duration}ms ease-in-out`,
  opacity: 0,
  maxHeight: 0,
  overflow: 'hidden',
};

const transitionStyles = {
  entering: { opacity: 0, maxHeight: 0 },
  entered: { opacity: 1, maxHeight: '100%' },
  exiting: { opacity: 1, maxHeight: '100%' },
  exited: { opacity: 0, maxHeight: 0 },
};

export default class GameIndex extends PureComponent {
  constructor() {
    super();

    this.fetchURL = FETCH_URL;
    this.camsURL = CAMS_URL;
    this.cookies = new Cookies();

    this.state = {
      activeForm: 'student',
      snackMsg: 'Welcome!',
      snackOpen: false,
      snackType: 'snack-success',
      firstName: '',
      lastName: '',
      email: '',
      gameCode: '',
      username: '',
      password: '',
      requestSent: false,
    };
  }

  handleSnackClose = () => {
    this.setState({ snackOpen: false });
  };

  onChange = (e) => {
    const { name, value } = e.target;

    if (name === 'gameCode') {
      if (value.match(/[^a-zA-Z0-9-]/g)) {
        e.target.value = value.replace(/[^a-zA-Z0-9]/g, '');
      }
    }

    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onStudentJoin = (e) => {
    e.preventDefault();
    this.setState({ requestSent: true });

    axios
      .post(this.fetchURL + '/api/v1/participants/', {
        student_name: this.state.firstName + ' ' + this.state.lastName,
        student_email: this.state.email,
        game_code: this.state.gameCode,
      })
      .then((response) => {
        // console.log(response.data);
        this.setState({ requestSent: false });

        if (response.data.success) {
          this.setState({
            snackOpen: true,
            snackMsg: `Authentication successful!`,
            snackType: 'snack-success',
          });
          const data = response.data.data;
          this.cookies.set('world_skey', data.world_skey, { maxAge: 86400 });
          this.cookies.set('world_name', data.world_name, { maxAge: 86400 });
          this.cookies.set('p_id', data.id, { maxAge: 86400 });
          this.cookies.set(
            's_name',
            this.state.firstName + ' ' + this.state.lastName,
            { maxAge: 86400 }
          );

          window.location.reload();
        } else {
          this.setState({
            snackOpen: true,
            snackMsg: response.data.message,
            snackType: 'snack-error',
          });
        }
      })
      .catch((error) => {
        console.log(error.response);
        this.setState({
          snackOpen: true,
          snackMsg: 'Something went wrong. Please try again later.',
          snackType: 'snack-error',
        });
        this.setState({ requestSent: false });
      });
  };

  onInstructorLogin = (e) => {
    e.preventDefault();

    this.setState({ requestSent: true });

    axios
      .post(this.camsURL + '/api/auth/login', {
        email: this.state.email,
        password: this.state.password,
      })
      .then((response) => {
        console.log(response.data);
        this.setState({ requestSent: false });

        if (response.data.success) {
          this.setState({
            snackOpen: true,
            snackMsg: `Authentication successful!`,
            snackType: 'snack-success',
          });
          const data = response.data;
          // console.log(data);
          this.cookies.set('token', data.token, { maxAge: 86400 });
          this.cookies.set('uid', data.uid, { maxAge: 86400 });
          window.location.replace('/instructor');
        } else {
          this.setState({
            snackOpen: true,
            snackMsg: response.data.message,
            snackType: 'snack-error',
          });
        }
      })
      .catch((error) => {
        console.log(error.response);
        this.setState({
          snackOpen: true,
          snackMsg: 'Something went wrong. Please try again later.',
          snackType: 'snack-error',
        });
        this.setState({ requestSent: false });
      });
  };

  clearCookies = () => {
    this.cookies.remove('p_id');
    this.cookies.remove('s_name');
    this.cookies.remove('world_id');
    this.cookies.remove('world_name');
    this.cookies.remove('world_skey');
    this.cookies.remove('config_number');
    this.cookies.remove('role_id');
    this.cookies.remove('role_name');
    this.cookies.remove('country_id');
    this.cookies.remove('country_name');
    this.cookies.remove('current_year');
    this.cookies.remove('token');
    this.cookies.remove('uid');
  };

  render() {
    return (
      <div className={`${this.props.display === 'show' ? 'active' : 'hidden'}`}>
        <div className="header__padding" />
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={this.state.snackOpen}
          onClose={this.handleSnackClose}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          className={this.state.snackType}
          autoHideDuration={5000}
          message={<span id="message-id">{this.state.snackMsg}</span>}
        />

        <div
          className={`flex flex-items-center flex-justify-center account__wrap`}
        >
          <div className="info__container" style={{ color: '#374151' }}>
            <h1 className="landingHero">
              <strong>Solve a humanitarian crisis.</strong>
            </h1>
            <h1 className="landingHero">
              <strong>Get real results. Hone real skills.</strong>
            </h1>
            <p>
              Faced with a migrant influx, teams negotiate a regional response,
              allocate limited resources, and weigh short-terms costs against
              long-term benefits.
            </p>
            <h3>Policy focus</h3>
            <ul>
              <li>Migration</li>
            </ul>

            <h3>Skills focus</h3>
            <ul>
              <li>Multi-party & bilateral negotiation</li>
              <li>Data analysis</li>
              <li>Consensus-building</li>
              <li>Trade-offs (long-term vs. short-term)</li>
            </ul>
          </div>

          <div className={`account__container ${this.state.activeForm}-active`}>
            <div
              className={`flex account__switcher ${
                this.state.activeForm
              }-active`}
            >
              <div
                className={`student-btn trigger`}
                onClick={() => {
                  this.setState((state) => ({
                    activeForm: 'student',
                  }));
                }}
              >
                Student
              </div>
              <div
                className={`instructor-btn trigger`}
                onClick={() => {
                  this.setState((state) => ({
                    activeForm: 'instructor',
                  }));
                }}
              >
                Instructor
              </div>
            </div>

            <div className={`shadow account__wrapper`}>
              <Transition
                in={this.state.activeForm === 'student'}
                timeout={300}
                unmountOnExit
              >
                {(state) => (
                  <div
                    style={{
                      ...defaultStyle,
                      ...transitionStyles[state],
                    }}
                  >
                    <h3>Join a game</h3>
                    <form
                      className="signup_form"
                      method="post"
                      onSubmit={(e) => this.onStudentJoin(e)}
                    >
                      <br />
                      <div className={`flex flex-wrap formRow`}>
                        <div className="formItem">
                          <label className="formLabel" htmlFor="firstName">
                            First Name <span style={{ color: 'red' }}>*</span>
                          </label>
                          <input
                            type="text"
                            className={`input__one account__input`}
                            name="firstName"
                            id="firstName"
                            placeholder=""
                            value={this.state.firstName}
                            onChange={(e) => this.onChange(e)}
                            required
                          />
                        </div>

                        <div className="formItem">
                          <label
                            ref={(a) => (this.labeltest = a)}
                            className="formLabel"
                            htmlFor="lastName"
                          >
                            Last Name <span style={{ color: 'red' }}>*</span>
                          </label>
                          <input
                            type="text"
                            className={`input__one account__input`}
                            name="lastName"
                            id="lastName"
                            value={this.state.lastName}
                            onChange={(e) => this.onChange(e)}
                            placeholder=""
                            required
                          />
                        </div>
                      </div>

                      <div className={`flex flex-wrap formRow`}>
                        <div className="formItemFull">
                          <label
                            ref={(a) => (this.labeltest = a)}
                            className="formLabel"
                            htmlFor="email"
                          >
                            Email <span style={{ color: 'red' }}>*</span>
                          </label>
                          <input
                            type="email"
                            className={`input__one account__input`}
                            name="email"
                            id="email"
                            value={this.state.email}
                            onChange={(e) => this.onChange(e)}
                            placeholder=""
                            required
                          />
                        </div>
                      </div>

                      <br />
                      <div className={`flex flex-wrap formRow`}>
                        <div className="formItemFull">
                          <label
                            ref={(a) => (this.labeltest = a)}
                            className="formLabel"
                            htmlFor="gameCode"
                          >
                            Game Code <span style={{ color: 'red' }}>*</span>
                          </label>
                          <span>Your instructor will provide this</span>
                          <input
                            type="text"
                            className={`input__one account__input`}
                            name="gameCode"
                            id="gameCode"
                            value={this.state.gameCode}
                            onChange={(e) => this.onChange(e)}
                            placeholder=""
                            required
                            style={{ marginTop: '10px' }}
                          />
                        </div>
                      </div>

                      <button
                        type="submit"
                        className="loginBtn button"
                        disabled={this.state.requestSent ? 'disabled' : ''}
                        style={{ marginTop: '15px', borderRadius: '4px' }}
                      >
                        {this.state.requestSent ? 'Joining . . .' : 'Join'}
                      </button>

                      <br />
                      <br />
                      <span className="switchLink" onClick={this.clearCookies}>
                        Clear Cookies
                      </span>
                    </form>
                  </div>
                )}
              </Transition>

              <Transition
                in={this.state.activeForm === 'instructor'}
                timeout={300}
                unmountOnExit
              >
                {(state) => (
                  <div
                    style={{
                      ...defaultStyle,
                      ...transitionStyles[state],
                    }}
                  >
                    <h3>Sign In to Your Account</h3>
                    <form
                      className="signup_form"
                      method="post"
                      onSubmit={(e) => this.onInstructorLogin(e)}
                    >
                      <br />
                      <div className={`flex flex-wrap formRow`}>
                        <div className="formItemFull">
                          <label className="formLabel" htmlFor="email">
                            Email <span style={{ color: 'red' }}>*</span>
                          </label>
                          <input
                            id="email"
                            name="email"
                            className={`input__one account__input`}
                            type="email"
                            value={this.state.email}
                            placeholder=""
                            required="required"
                            onChange={(e) => this.onChange(e)}
                          />
                        </div>
                      </div>

                      <div className={`flex flex-wrap formRow`}>
                        <div className="formItemFull">
                          <label className="formLabel" htmlFor="password">
                            Password <span style={{ color: 'red' }}>*</span>
                          </label>
                          <input
                            id="password"
                            name="password"
                            type="password"
                            value={this.state.password}
                            placeholder=""
                            className={`input__one account__input`}
                            required="required"
                            onChange={(e) => this.onChange(e)}
                          />
                        </div>
                      </div>

                      <button
                        type="submit"
                        className="loginBtn button"
                        style={{ marginTop: '15px', borderRadius: '4px' }}
                      >
                        Login
                      </button>

                      <br />
                      <br />
                      <span className="switchLink" onClick={this.clearCookies}>
                        Clear Cookies
                      </span>
                    </form>
                  </div>
                )}
              </Transition>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
